import React from 'react';
import { sort } from 'utils/sort';
import SelectedCriterion from './SelectedCriterion';
import AddCriteria from './AddCriteria';

const SelectedCriteriaList = ({
  selectedCriteria,
  handleUpdate,
  canUseCustomFeedbackCriteria,
}) => {
  const deleteCriterion = id => {
    const filteredSelectedCriteria = selectedCriteria.filter(
      selectedCriterion => selectedCriterion.id !== id,
    );

    handleUpdate(filteredSelectedCriteria);
  };

  const sortedCriteria = sort(selectedCriteria, 'name');
  return (
    <div className="FeedbackCriteria-criteriaList">
      {sortedCriteria.map(selectedCriterion => (
        <SelectedCriterion
          selectedCriterion={selectedCriterion}
          key={selectedCriterion.id}
          handleUpdate={handleUpdate}
          deleteCriterion={deleteCriterion}
        />
      ))}
      <AddCriteria
        canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
        selectedCriteria={selectedCriteria}
        handleUpdate={handleUpdate}
      />
    </div>
  );
};

export default SelectedCriteriaList;
